<script setup>
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

const { t } = useI18n()

const props = defineProps({
  status: {
    type: String,
    required: true
  },
  withAlert: {
    type: Boolean,
    default: false
  }
})

const getStatusColor = (status) => {
  const colors = {
    pending: '', // warning
    won: 'success',
    lost: 'error',
    void: 'grey'
  }
  return colors[status] || 'grey'
}

const getStatusIcon = (status) => {
  const icons = {
    pending: 'mdi-clock-outline',
    won: 'mdi-check-circle',
    lost: 'mdi-close-circle',
    void: 'mdi-cancel'
  }
  return icons[status] || 'mdi-help-circle'
}

const getStatusText = (status) => {
  const texts = {
    pending: t('myBets.status.pending'),
    won: t('myBets.status.won'),
    lost: t('myBets.status.lost'),
    void: t('myBets.status.void')
  }
  return texts[status] || status
}

const color = computed(() => getStatusColor(props.status))
const icon = computed(() => getStatusIcon(props.status))
const text = computed(() => getStatusText(props.status))
</script>

<template>
  <v-alert
    v-if="withAlert"
    :color="color"
    variant="tonal"
    density="compact"
    rounded="lg"
    class="mb-0"
  >
    <div class="d-flex align-center justify-center">
      <v-icon start size="small">{{ icon }}</v-icon>
      {{ text }}
    </div>
  </v-alert>

  <v-chip v-else
    :color="color"
    size="small"
    variant="tonal"
  >
    <div class="d-flex align-center justify-center">
      <v-icon start size="small">{{ icon }}</v-icon>
      {{ text }}
    </div>
  </v-chip>
</template>

<style scoped>
</style>
